import { PropsWithClassName } from "shared/props"

import styles from './Image.module.scss';

export const AuthSignInImage = <TProps extends PropsWithClassName>(props: TProps) => {
	return <div className={`${props.className} ${styles.container}`}></div>
}
